import { Price, Status } from "@/types";

type ItemOffer = {
  id: string;
  availabilityId: string[];
  index: number;
  itemId: string;
  optionGroupsId?: string[];
  price: Price;
  status: Status;
  displayMode?: ItemOfferDisplayMode;
  isPromotional?: boolean;
  promotionalBannerText?: string;
  allowsSpecialInstructions?: boolean;
  /** Menu entry shown on the "Itens em destaque" rail (set when any offer of its product is featured). */
  isFeatured?: boolean;
};

export enum ItemOfferDisplayMode {
  LIST = "LIST",
  STEP_BY_STEP = "STEP_BY_STEP",
}

export default ItemOffer;
